import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';

import Header from './base/Header';
import SeoSocial from './base/SeoSocial';

import '~styles/base.scss';

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
      query LayoutQuery {
          site {
              siteMetadata {
                  title
              }
          }
      }
  `);

  return (
    <React.Fragment>
      <SeoSocial title={data.site.siteMetadata.title} />
      <Header />
      <main id="content">
        {children}
      </main>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
